// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/methods/firstparty/v1/get_methods.proto

/* oxlint-disable */
import { ApiMethod } from "./common";

/** Response message for GetMethods. */
export interface ApiGetMethodsResponse {
  /** List of methods. */
  readonly methods: readonly ApiMethod[];
}

/** Request message to retrieve available payment methods. */
export interface ApiGetMethodsRequest {
}

export const ApiGetMethodsResponse: MessageFns<ApiGetMethodsResponse> = {
  fromJSON(object: any): ApiGetMethodsResponse {
    return {
      methods: globalThis.Array.isArray(object?.methods) ? object.methods.map((e: any) => ApiMethod.fromJSON(e)) : [],
    };
  },

  toJSON(message: ApiGetMethodsResponse): unknown {
    const obj: any = {};
    if (message.methods?.length) {
      obj.methods = message.methods.map((e) => ApiMethod.toJSON(e));
    }
    return obj;
  },
};

export const ApiGetMethodsRequest: MessageFns<ApiGetMethodsRequest> = {
  fromJSON(_: any): ApiGetMethodsRequest {
    return {};
  },

  toJSON(_: ApiGetMethodsRequest): unknown {
    const obj: any = {};
    return obj;
  },
};

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
